// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__piMLk","sendOtp":"AuthorizeToLogin_sendOtp__2b_IA"};